import getPhysicalCabinName from './getPhysicalCabinName';
/**
 * 比较两个舱位级别
 * @param {string} c1 舱位1
 * @param {string} c2 舱位2
 * @returns {Number} -1 c1<c2;  0 c1=c2;  1 c1>c2
 */
export default function compareCabin(c1, c2) {
    var cName1 = getPhysicalCabinName(c1);
    var cName2 = getPhysicalCabinName(c2);
    if (cName1 === cName2)
        return 0;
    if (cName1 === '头等舱')
        return 1;
    if (cName1 === '公务舱' && cName2 !== '头等舱')
        return 1;
    if (cName1 === '明珠经济舱' && !['头等舱', '公务舱'].includes(cName2))
        return 1;
    if (cName1 === '经济舱' && !['头等舱', '公务舱', '明珠经济舱'].includes(cName2))
        return 1;
    return -1;
}



//////////////////
// WEBPACK FOOTER
// ../emp-helpers/dist/es/business/compareCabin.js
// module id = null
// module chunks = 